// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T20:46:09.013Z
// Property: 110 Roy Apartments (ID: 6767906449166921)
// Collections: 78 amenities, 6 floorplans (live), 12 photos, 78 POIs, 2 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449166921",
  "property_external_id": "77603",
  "property_zillow_url": "https://www.zillow.com/apartments/seattle-wa/110-roy-apartments/Ch8BZS/",
  "property_apartments_url": "https://www.apartments.com/110-roy-apartments-seattle-wa/swv1xf7/",
  "property_google_business_url": "https://www.google.com/maps/place/110+Roy+Apartments/data=!4m2!3m1!1s0x0:0x487533098f962edd?sa=X&ved=2ahUKEwjfmcie0LiSAxXdTTABHR5MApMQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "110-roy-apartments",
  "property_name": "110 Roy Apartments",
  "property_website_url": "https://www.110roy.com/",
  "property_domain": null,
  "property_address": "110 Roy Street",
  "property_full_address": "110 Roy St, Seattle, WA 98109, USA",
  "property_address_1": "110 Roy Street",
  "property_address_2": null,
  "property_address_city": "Seattle",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98109",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Uptown",
  "property_address_latitude": "47.62566",
  "property_address_longitude": "-122.3548387",
  "property_email": null,
  "property_phone": "(425) 517-3203",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Uptown Seattle living, elevated.</strong> Explore studio to two-bedroom apartments with polished finishes, smart features, and skyline-view spaces—then schedule your tour of 110 Roy today.</p>",
  "property_long_description": "<p><strong>Live where Uptown’s skyline, culture, and convenience meet.</strong> At 110 Roy Apartments, you’re moments from Seattle Center, Climate Pledge Arena, the Space Needle, Queen Anne dining, and the Monorail connection to downtown—placing concerts, cafés, nightlife, transit, and waterfront green space all within easy reach.</p><p>Inside, choose from studio, open one-bedroom, one-bedroom, and two-bedroom <a href=\"/floor-plans\">apartment layouts</a> designed with air conditioning, chef-style kitchens, stainless-steel appliances, quartz countertops, full-height tile backsplashes, front-loading laundry, hardwood-style plank flooring, smart lock technology, and select balconies, terraces, or extra-high ceilings.</p><p>Above it all, the <a href=\"/amenities\">Skyview Terrace</a> brings expansive views of the Seattle skyline, Space Needle, Elliott Bay, and Mount Rainier with a fire pit, grilling, and lounge areas. Add a 24-hour fitness studio, resident lounge with private work-from-home spaces, controlled-access garage parking with EV charging, package lockers, bike storage with repair station, and pet-friendly perks, and 110 Roy gives you a polished home base in one of Seattle’s most connected cultural districts.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-7c82-7089-8ffb-e98280d91a11.webp",
  "property_featured_image_media": {
    "alt_text": "Rooftop patio seating area with city skyline view.",
    "public_id": "019cfde2-7c82-7089-8ffb-e98280d91a11",
    "storage_key": "property/6767906449166921/019cfde2-7c82-7089-8ffb-e98280d91a11.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "167",
  "property_year_built": "2025",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.01197604790418",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "600",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum 2 pets per unit. Breed restrictions apply.",
  "property_pet_policy_description": "Dogs and cats allowed. Dog deposit: $300 per pet; dog rent: $50/month per pet. Cat deposit: $300 per pet; cat rent: $50/month per pet. Maximum 2 pets per unit. Breed restrictions apply.",
  "property_petpolicy_info": "This is a pet blurb",
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f1eae-6bff-72f8-b2ff-af14565bd3fe.webp",
  "property_primary_logo_media": {
    "alt_text": "Seven 88 West Midtown logo",
    "public_id": "019f1eae-6bff-72f8-b2ff-af14565bd3fe",
    "storage_key": "property/6767906449166921/019f1eae-6bff-72f8-b2ff-af14565bd3fe.webp",
    "width": 320,
    "height": 379
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-706e-739b-be58-0c990844bf46.webp",
  "property_secondary_logo_media": {
    "alt_text": "110 Roy Queen Anne logo",
    "public_id": "019cfde2-706e-739b-be58-0c990844bf46",
    "storage_key": "property/6767906449166921/019cfde2-706e-739b-be58-0c990844bf46.webp",
    "width": 1920,
    "height": 1118
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f1eae-d8e4-750e-b02e-d85d5f3a28c7.webp",
  "property_mono_white_logo_media": {
    "alt_text": "110 Roy Queen Anne logo",
    "public_id": "019f1eae-d8e4-750e-b02e-d85d5f3a28c7",
    "storage_key": "property/6767906449166921/019f1eae-d8e4-750e-b02e-d85d5f3a28c7.webp",
    "width": 320,
    "height": 379
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f1eae-c00f-75ba-a3a4-7ddbc3066e41.webp",
  "property_mono_black_logo_media": {
    "alt_text": "110 Roy Queen Anne logo",
    "public_id": "019f1eae-c00f-75ba-a3a4-7ddbc3066e41",
    "storage_key": "property/6767906449166921/019f1eae-c00f-75ba-a3a4-7ddbc3066e41.webp",
    "width": 320,
    "height": 379
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#fbf3f3",
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "513 - 1,039 sq ft",
  "property_sqft_min": "513",
  "property_sqft_max": "1,039",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/456172570912353",
  "property_instagram_url": "https://www.instagram.com/p/DTDs3XeDxUi/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJKUuOhjwVkFQR3S6WjwkzdUg",
  "property_youtube_url": "https://www.youtube.com/@110Roy_Dyverse",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Queen+Anne+Apartments&find_loc=Seattle%2C+WA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 110 Roy Apartments",
  "property_home_romance_title": "Embrace the Joy of Life in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Amenities with a skyline edge.</strong> Rise above Lower Queen Anne on the rooftop Skyview Terrace, where grilling stations, fireside seating, open-air lounging, and city views set the scene. Indoors, enjoy free common-area WiFi, a 24-hour fitness studio, and a resident lounge with focus spaces, entertainment seating, and a pool table. Apartment details like chef-style kitchens, air conditioning, front-loading laundry, expansive windows, smart locks, and select outdoor spaces complete the experience.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with polish, from studio to two bedroom.</strong> Discover air-conditioned homes with hardwood-style plank flooring, chef-style kitchens, stainless-steel appliances, quartz countertops, full-height tile backsplashes, and front-loading laundry. Select floor plans add private outdoor space, extra-high ceilings, skyline outlooks, or walk-in closets—giving each 110 Roy apartment a little more room to stand out.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at 110 Roy.</strong> Preview bright interiors with wide windows, quartz-topped chef-style kitchens, tile backsplashes, and select outdoor spaces with expanded views. Then picture the rooftop Skyview Terrace with fireside seating, skyline outlooks, resident lounge, fitness studio, pet-friendly spaces, and polished everyday conveniences—all captured in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Uptown keeps Seattle close.</strong> From 110 Roy Apartments, walk to Queen Anne Beerhall, Sal Y Limón, Seattle Center, McCaw Hall, SIFF Cinema Uptown, KEXP, and the arena scene. For open air, Myrtle Edwards Park and the Elliott Bay Trail bring waterfront paths, public art, and mountain-and-bay views. With nearby buses and the Seattle Center Monorail to Westlake, the city stays easy to reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews say it best.</strong> At 110 Roy, feedback often calls out the well-kept community, welcoming tours, and a responsive team that makes daily living smoother—from leasing support to maintenance help. Residents also praise the Uptown location as “super walkable, and close to everything.” Read more reviews to see life at 110 Roy in their own words.</p>",
  "property_neighborhood_blurb": "<p><strong>Uptown puts Seattle in motion around you.</strong> Step out for a pre-show bite at Queen Anne Beerhall, Sal Y Limón, or The Masonry, then follow the neighborhood’s easy energy toward Seattle Center, McCaw Hall, SIFF Cinema Uptown, KEXP, and the arena scene.</p><p>When you want open air, head west to Myrtle Edwards Park and the Elliott Bay Trail for waterfront paths, beach coves, public art, and mountain-and-bay views. Downtown is simple, too, with nearby bus options and the Seattle Center Monorail linking you to Westlake in minutes. From coffee runs to curtain times, dinner plans to waterfront rides, 110 Roy Apartments places your day within a walkable Uptown grid—then brings you back to elevated comfort. <a href=\"/schedule-a-tour\">Schedule a tour</a> and explore the neighborhood from here.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities with a point of view.</strong> At 110 Roy Apartments, everyday convenience meets polished design—starting with a rooftop Skyview Terrace made for open-air lounging, grilling, fireside downtime, and skyline watching above Lower Queen Anne.</p><p>Inside the community, free common-area WiFi, a 24-hour fitness studio, and a resident lounge with focus spaces, entertainment seating, and a pool table give you more ways to use your time well. At home, chef-style kitchens, air conditioning, front-loading laundry, expansive windows, smart lock technology, and select balconies, patios, terraces, or extra-high ceilings bring comfort into the details. Controlled-access garage parking with EV charging, package lockers, bike storage with a repair station, and pet-friendly perks—including a rooftop pet area and Pet Spaw—round out a connected, thoughtfully equipped Seattle lifestyle. <a href=\"/gallery\">See the spaces</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at 110 Roy.</strong> Choose a polished studio to two-bedroom layout with chef-style kitchens, quartz countertops, front-loading laundry, smart locks, and hardwood-style plank flooring. With skyline views, work-from-home spaces, fitness, parking, and pet-friendly perks, applying online is an easy next step.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact the leasing team at 110 Roy Apartments for details about available layouts, in-home finishes, community spaces, or directions to our Uptown Seattle address. Reach out today and let us help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about 110 Roy?</strong> Start here for quick answers about the community, leasing, apartment features, amenities, and everyday details. If you need more help or want specifics about availability, the leasing team is happy to assist.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you want to live.</strong> At 110 Roy Apartments, floor plans range from efficient studios to open one-bedroom designs, classic one-bedroom homes, and spacious two-bedroom layouts—all with polished details that make each plan feel intentional. Picture an air-conditioned home with hardwood-style plank flooring, a chef-style kitchen with stainless-steel appliances, quartz countertops, full-height tile backsplash, and in-home front-loading laundry. Select residences add private outdoor space, extra-high ceilings, skyline outlooks, or a walk-in closet for even more room to settle in. Browse current availability, compare pricing, and explore the <a href=\"/amenities\">features and finishes</a> that bring these Uptown apartments into focus, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you find your match.</p>",
  "property_gallery_blurb": "<p><strong>See 110 Roy Apartments from every angle.</strong> Browse photos that bring the details into focus: light-filled interiors with wide windows, sleek chef-style kitchens with quartz surfaces and tile backsplashes, and select outdoor spaces that open the view even wider. The gallery also captures the community’s most camera-ready moments, from the rooftop Skyview Terrace with fireside seating and skyline outlooks to the resident lounge, fitness studio, pet-friendly spaces, and polished everyday conveniences. Start here for a visual sense of the finishes, amenities, and Uptown setting, then explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore 110 Roy from every angle.</strong> Use the interactive map to browse available apartments and see how Uptown’s dining, culture, transit, and waterfront green space connect around this polished Seattle home base.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with the details handled.</strong> At 110 Roy Apartments, dogs and cats have room in the routine—from a quick visit to the designated rooftop pet area to an easy rinse at the self-service Pet Spaw after rainy-day walks. Your Uptown setting keeps everyday outings simple, with sidewalks for around-the-block strolls, nearby access to the waterfront trail, and Kinnear Park’s off-leash area within the broader Queen Anne area. Back at home, common-area WiFi, bike storage, controlled-access garage parking, and the rooftop Skyview Terrace add convenience for the rest of your day. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, review the policy details below, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how life with your pet fits here.</p>",
  "property_referafriend_blurb": "<p><strong>Share life at 110 Roy.</strong> If you love the polished apartments, Skyview Terrace, pet-friendly perks, and connected Uptown setting, invite a friend to experience it too. Send a referral today and help them discover a Seattle home base with skyline views, smart finishes, and everyday convenience.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at 110 Roy.</strong><br>Manage daily details from your polished Uptown home base—pay rent, submit maintenance requests, and keep your account up to date with ease.</p>",
  "property_reviews_blurb": "<p><strong>Real resident feedback, right from 110 Roy.</strong> Reviews highlight a beautifully maintained property, a welcoming tour experience, and a team that residents describe as responsive, professional, and caring. From leasing support with Nathalie to maintenance help from Blake, residents consistently point to service that makes everyday apartment living feel easier.</p><p>You’ll also see praise for the Uptown setting, described by one resident as “super walkable, and close to everything.” Browse the reviews below to hear how residents describe life at 110 Roy Apartments in their own words.</p>",
  "property_created_at": "1762986360464",
  "property_scheduletour_blurb": "<p><strong>See 110 Roy from the inside out.</strong> Tour polished layouts with chef-style kitchens, quartz countertops, smart lock technology, and select outdoor spaces—then head up to the Skyview Terrace for skyline, Elliott Bay, and Mount Rainier views. Schedule your visit and picture your next Seattle home base in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>The 110 Roy leasing team will be in touch soon to help with your next steps. In the meantime, explore polished apartment layouts, skyline-view spaces, and thoughtful everyday conveniences that make this Uptown Seattle address a standout home base.</p>",
  "property_virtualtours_blurb": "At 110 Roy in vibrant Seattle, WA, your ideal living space awaits! Choose from sleek studios, spacious one, or comfortable two-bedroom floor plans, each designed for modern living. Dive into our virtual tour and envision your new home in this welcoming community—where your Seattle adventure begins!",
  "property_copyright": "Fake copyright",
  "property_seo_title_home": "110 Roy Apartments |  Apartments in Seattle, WA",
  "property_seo_description_home": "Experience urban living at 110 Roy Apartments in Lower Queen Anne! Enjoy skyline views, fitness facilities, and modern layouts. Find your perfect Seattle home!",
  "property_seo_title_floorplans": "Floor Plans | Seattle, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at 110 Roy Apartments in Seattle! Choose from stylish studios, one- and two-bedroom layouts that fit your lifestyle. Explore today!",
  "property_seo_title_amenities": "Amenities | Seattle, WA Apartments for Rent",
  "property_seo_description_amenities": "Relax at 110 Roy Apartments in Lower Queen Anne, Seattle! Enjoy rooftop views, a 24/7 fitness studio, pet-friendly spaces, and nearby nightlife.",
  "property_seo_title_gallery": "Gallery | Apartments in Seattle, WA",
  "property_seo_description_gallery": "Experience Seattle living at 110 Roy Apartments—modern comforts, stunning skyline views, and a vibrant community with endless amenities!",
  "property_seo_title_virtualtours": "Virtual Tours | 110 Roy Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside 110 Roy Apartments in Seattle, WA! Experience our studio, one, and two-bedroom homes. Take a virtual tour today and envision your new lifestyle!",
  "property_seo_title_interactivemap": "Interactive Map | 110 Roy Apartments Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at 110 Roy Apartments in Seattle's vibrant Lower Queen Anne! Use our interactive map to view floor plans, pricing, and nearby hotspots.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Seattle, WA",
  "property_seo_description_neighborhood": "Uncover the vibrant Seattle scene around 110 Roy Apartments. From local favorites to hidden gems, enjoy the perfect blend of city life and community charm!",
  "property_seo_title_contact": "Contact Us | 110 Roy Apartments",
  "property_seo_description_contact": "Reach out to our leasing team at 110 Roy Apartments in Seattle! From studios to two-bedroom homes, we’re here to answer all your inquiries.",
  "property_seo_title_faqs": "FAQs | Apartments in Seattle, WA",
  "property_seo_description_faqs": "Find answers to your questions at 110 Roy Apartments! Located in Lower Queen Anne, enjoy luxury amenities and stunning Seattle skyline views.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Seattle, WA",
  "property_seo_description_reviews": "Uncover why residents love 110 Roy Apartments in Seattle! Enjoy stylish living with stunning views, vibrant amenities, and a prime Lower Queen Anne location.",
  "property_seo_title_applynow": "Apply Now | Apartments in Seattle, WA",
  "property_seo_description_applynow": "Discover urban living at 110 Roy Apartments in Lower Queen Anne with skyline views, luxury amenities, and Seattle's vibrancy at your doorstep!",
  "property_seo_title_residentaccess": "Resident Access | 110 Roy Apartments",
  "property_seo_description_residentaccess": "Experience effortless living at 110 Roy Apartments! Use the resident portal for rent payments, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | 110 Roy Apartments",
  "property_seo_description_referafriend": "Refer a friend to 110 Roy Apartments in Seattle! Great friends make great neighbors—join our vibrant community and enjoy the perks of city living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | 110 Roy Apartments",
  "property_seo_description_scheduletour": "Experience urban living at 110 Roy Apartments in Seattle, WA. Schedule your tour today and find your perfect home amidst vibrant city life!",
  "property_seo_title_privacy": "Privacy Policy | 110 Roy Apartments",
  "property_seo_description_privacy": "At 110 Roy Apartments, your privacy matters. Discover how we safeguard your information for a secure living experience. View our policy!",
  "property_seo_title_accessibility": "Website Accessibility | 110 Roy Apartments",
  "property_seo_description_accessibility": "At 110 Roy Apartments in Seattle, we prioritize accessibility and digital inclusion for all. Experience a community designed for everyone. Join us today!",
  "property_seo_title_sitemap": "Sitemap | 110 Roy Apartments",
  "property_seo_description_sitemap": "Navigate your future home at 110 Roy Apartments in Seattle! Our sitemap guides you through our vibrant community and amenities. Click to plan your visit!",
  "property_seo_title_thankyou": "Thank You | 110 Roy Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to vibrant living at 110 Roy Apartments in Seattle awaits. Our team will connect with you soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Seattle, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1788981235017",
  "amenities": [
    {
      "id": "ec_b39ca64359a9bfb6c2455b0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52448b55ab723f2dfbad3833",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0aee5cd7e9e654accbe7f6f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_836acbd8f3c760892b157127",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "On-Site Retail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_985b65ffc5d8ea7e8304978b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36e777a93c5893cf8b3a2872",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85635e7737fe2b20b2fd6403",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fe32216b60c74c07bf710af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Renters Insurance Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63f231f318c08283fad1fda7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4a8aed990a58560166c3441",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Community-Wide WiFi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca7320ffc8f84a6bf4ec1590",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_20e002503a550f21cd9e0415",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74595a7b179bca6d739f2e54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f5f465dccf51e3aedfbfc86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Key Fob Entry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de9942d53976d26625b645e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a33d50beb41ff8737bf4685e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df856c883ef54a1c2394d04f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Breakfast/Coffee Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0691e971921308c6b0d3d697",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal Chutes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f2e6b7d4cd8f2c0c7f28219",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f68d7500463bba2975f377b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Conference Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83a0e41f20325ad482f23b02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_065af62d1746c6e146015109",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a164b259f87941110ed9817",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Multi Use Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_898f20d32c82c1fedfa7dac3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Roof Terrace",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b01d07cab74b77e7eb8935ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_feb398b5da55a630fec3f890",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Bicycle Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b3b6eb6ad9f13d072ab7ec8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Study Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1f6ba1d8c7c84ce4e2c2580",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "24-Hour Fitness Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d1128bcbf00cd53bc003861",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Air conditioning in every home",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16ec6e417de68fc443a3b559",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Biometric built-in wall safe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2baca08b515c002fd85f3f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Contemporary cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ecbf641e736cf726b2c4238",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Expansive light-filled windows",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc4aaebf5a7a33d61c52a0c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Extra high ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a8863ad94daaf4b3e5715cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Free WiFi available in all common areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80962949dcd4a57cf7361d4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Full-capacity front-loading washer and dryer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62fe40e3d20913d8e52dc148",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "High end hardwood-style plank flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c13e2833c99b28942ccbd450",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Large terraces and patios*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7904f3dc9bc8150182dc1a44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Private balconies in most homes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d28ec60d9d70395979513ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Residential and bike storage with repair station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_550d69d60e6a95f09ab9282c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Secured access package lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cde0b73e19aba4cd0e5caa3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Video entry system with remote access capability",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74a132f314485874460d0e10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc70467cb0e9d6709de8ead4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0842088027051cb9026b6492",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a22bf3f899e1b05df49c2cb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f69dcdbfdf2559c67cdce0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Security System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d614a0907c987968aac3de53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a3eb46c8d0d4ab4e286c00a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_002dc4b1195ae21f44df855e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf8174a1f015acb2879ac43d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Intercom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6602d6ffbe7f90c99b50a08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aca257357ed74ae8f8845c3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Trash Compactor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_503a6bc51bf2246c5230fe01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad21e0ab8db88f9ebcdf0a62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5fd5ea9076002738058bce71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62220fd54c4063f435774a00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_955e661500106ef82da6814b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Eat-in Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d0afe89919516538d5749f16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc881c1b801e574f861ac319",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e6068a269f6a63e5f542598",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e84ae0a82c67a97ab7437ffd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d50c5e65e70cedfbe1faaf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_974e68055d61723ea917e228",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2da17c7e076796ae6afcb6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Breakfast Nook",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6992a528f952a9326f0f4a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a97349e40cb83a94e796f6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Island Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c976636672d370f98b21b2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b89d09650bfed9c94a4f3151",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4240ae9a2ad0ad7c48f2c28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Tile Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af899093f0258619820a7803",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8e49e8e35cf07fa5470b81a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_421ac7c22a807d2a388bd084",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_370f989733d69c2deb517a0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Family Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ca5a36526bc76db4f9b9120",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac4a3d94bcb4bdc2738be435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e3d8da623ca4fce573fd945",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Floor to Ceiling Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2ee1cbaecf2e90ba6ac763c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cd469004a4eeb270a73f22e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ab339afb-c560-48c9-a1bd-cf9a4e66addf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde5-0fc1-770c-9cc3-fc9123e1cb08.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer stacked in a closet.",
        "public_id": "019cfde5-0fc1-770c-9cc3-fc9123e1cb08",
        "storage_key": "property/6767906449166921/019cfde5-0fc1-770c-9cc3-fc9123e1cb08.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Other",
      "description": "Convenient in-unit stacked washer and dryer for easy laundry access.",
      "link": "",
      "alt_text": "In-unit washer and dryer stacked in a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/a-d8b13NJok7SVhZ7CCh_vvokz7UGtGt5gNmuVqry7Q/116/110-roy-apartments-seattle-wa-building-photo.jpg"
    },
    {
      "id": "custom_c53a308c-8f39-4d1a-8e6f-7ec7c6acc3da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-8c97-74da-bb38-b346220dc467.webp",
      "image_media": {
        "alt_text": "Modern apartment living room with a blue sofa, fireplace, and built-in shelving. TEST",
        "public_id": "019cfde2-8c97-74da-bb38-b346220dc467",
        "storage_key": "property/6767906449166921/019cfde2-8c97-74da-bb38-b346220dc467.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Stylish open-concept living area with a contemporary fireplace, media wall, and decorative shelving—ideal for entertaining.",
      "link": "",
      "alt_text": "Modern apartment living room with a blue sofa, fireplace, and built-in shelving. TEST",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2F708b771ab77db451210e2a4105c172ad.jpg"
    },
    {
      "id": "custom_b7876bdc-d018-4b3c-a4dd-4b4c192463bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-c1b6-7106-b3b5-28dbea484628.webp",
      "image_media": {
        "alt_text": "Open-concept living room and kitchen in a modern apartment with city-view windows.",
        "public_id": "019cfde2-c1b6-7106-b3b5-28dbea484628",
        "storage_key": "property/6767906449166921/019cfde2-c1b6-7106-b3b5-28dbea484628.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Bright, modern apartment interior with a kitchen island, wood cabinets, and expansive city views.",
      "link": "",
      "alt_text": "Open-concept living room and kitchen in a modern apartment with city-view windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2Fc73ce5b4998ce0e50452074b107d5cf9.jpg"
    },
    {
      "id": "custom_75064b7d-ce89-455d-9e2e-ee3b0db28d53",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-def9-7388-91d5-0e26fca48d61.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with a bed, two nightstands, lamps, and a large window with city views.",
        "public_id": "019cfde3-def9-7388-91d5-0e26fca48d61",
        "storage_key": "property/6767906449166921/019cfde3-def9-7388-91d5-0e26fca48d61.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright contemporary bedroom in an urban apartment with panoramic windows and cityscape views.",
      "link": "",
      "alt_text": "Bedroom in a modern apartment with a bed, two nightstands, lamps, and a large window with city views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2F7594167a20c37d5d8d1cad83049ce707.jpg"
    },
    {
      "id": "custom_11a0a07a-d340-4569-9676-dda0d12da061",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde5-100a-77ba-871d-44a28e681582.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a city view.",
        "public_id": "019cfde5-100a-77ba-871d-44a28e681582",
        "storage_key": "property/6767906449166921/019cfde5-100a-77ba-871d-44a28e681582.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Other",
      "description": "Cozy bedroom featuring a comfortable king-size bed, stylish nightstands, and a breathtaking city view. Perfect for relaxation and enjoying urban living.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a city view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/lY3arIRE4zGXo8RiKnSE3ZBEdpLaCqBzXu7AXnHwJN4/116/110-roy-apartments-seattle-wa-building-photo.jpg"
    },
    {
      "id": "custom_62c475f7-3df7-4ac3-9072-2381cc6b97e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-df06-740d-a911-6fa39bd80f4d.webp",
      "image_media": {
        "alt_text": "[TEST] Modern apartment kitchen with dark wood cabinets, stainless appliances, white subway backsplash, and living area beyond.",
        "public_id": "019cfde3-df06-740d-a911-6fa39bd80f4d",
        "storage_key": "property/6767906449166921/019cfde3-df06-740d-a911-6fa39bd80f4d.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright, modern kitchen in a stylish apartment with dark wood cabinets, stainless appliances, and an open living area.",
      "link": "",
      "alt_text": "[TEST] Modern apartment kitchen with dark wood cabinets, stainless appliances, white subway backsplash, and living area beyond.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2F09b105ab4252779306b57620f5487cd1.jpg"
    },
    {
      "id": "custom_88cd4b1a-2f5a-4a75-982c-21869dba344a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde5-0fd9-77eb-ab1a-7097718d37ea.webp",
      "image_media": {
        "alt_text": "Gym with weight racks, dumbbells, and city skyline mural.",
        "public_id": "019cfde5-0fd9-77eb-ab1a-7097718d37ea",
        "storage_key": "property/6767906449166921/019cfde5-0fd9-77eb-ab1a-7097718d37ea.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Other",
      "description": "State-of-the-art fitness center featuring weight racks, dumbbells, and a vibrant city skyline mural.",
      "link": "",
      "alt_text": "Gym with weight racks, dumbbells, and city skyline mural.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/FZ-tYlNEQIE0HHNR138iK69ZGICWD3SkDDZ95Es0IFI/116/110-roy-apartments-seattle-wa-building-photo.jpg"
    },
    {
      "id": "custom_8f53e1ec-40dd-4052-9f37-e58b56d83eee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-c1b6-7106-b3b5-28dbea484628.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen with island and large windows offering city skyline views.",
        "public_id": "019cfde2-c1b6-7106-b3b5-28dbea484628",
        "storage_key": "property/6767906449166921/019cfde2-c1b6-7106-b3b5-28dbea484628.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Modern apartment interior featuring a bright open kitchen with white countertops, dark wood cabinets, and cityscape views.",
      "link": "",
      "alt_text": "Open-concept kitchen with island and large windows offering city skyline views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/temporary-image-gallery/5767906449162273%2F6767906449166921%2Fc73ce5b4998ce0e50452074b107d5cf9.jpg"
    },
    {
      "id": "custom_4a085c1b-8de9-4fa7-9bc2-c4105ad715d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-cd7f-7027-88fa-0cc91f5c5c08.webp",
      "image_media": {
        "alt_text": "Bright living room in a modern apartment with large windows and a curved white sofa.",
        "public_id": "019cfde2-cd7f-7027-88fa-0cc91f5c5c08",
        "storage_key": "property/6767906449166921/019cfde2-cd7f-7027-88fa-0cc91f5c5c08.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "A stylish living room in a modern apartment showcasing city views, soft tones, and contemporary furnishings.",
      "link": "",
      "alt_text": "Bright living room in a modern apartment with large windows and a curved white sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/temporary-image-gallery/5767906449162273%2F6767906449166921%2Ff6a8fe73b15217071075425ab2aeb9cb.jpg"
    },
    {
      "id": "custom_48e94ac7-1803-47ae-b38b-3f60093d26bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-deef-75b8-95a2-b432dc0662e6.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with glass-enclosed shower, white countertop, and dark wood vanity.",
        "public_id": "019cfde3-deef-75b8-95a2-b432dc0662e6",
        "storage_key": "property/6767906449166921/019cfde3-deef-75b8-95a2-b432dc0662e6.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment bathroom with a glass shower, white counter, and a dark wood vanity with ample storage.",
      "link": "",
      "alt_text": "Modern apartment bathroom with glass-enclosed shower, white countertop, and dark wood vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2Fb7adaf8ee93483ff613ca4baea867088.jpg"
    },
    {
      "id": "custom_da07e228-d597-4fe7-9a3d-efd565e7dbaa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-ea03-773e-9353-bcc2872777fe.webp",
      "image_media": {
        "alt_text": "Modern apartment community lobby with blue accent wall, fireplace, shelves, and seating.",
        "public_id": "019cfde3-ea03-773e-9353-bcc2872777fe",
        "storage_key": "property/6767906449166921/019cfde3-ea03-773e-9353-bcc2872777fe.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Contemporary lobby with a fireplace, artwork, and stylish seating for residents and guests.",
      "link": "",
      "alt_text": "Modern apartment community lobby with blue accent wall, fireplace, shelves, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162273%2F6767906449166921%2F9cd8b9135357a3c0c0b924c5ea8ef107.jpg"
    },
    {
      "id": "custom_f751ceee-8601-4837-a785-93dc0d2e65ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde5-0fd9-77eb-ab1a-7097718d37ea.webp",
      "image_media": {
        "alt_text": "Gym with weight racks, dumbbells, and city skyline mural.",
        "public_id": "019cfde5-0fd9-77eb-ab1a-7097718d37ea",
        "storage_key": "property/6767906449166921/019cfde5-0fd9-77eb-ab1a-7097718d37ea.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring weight racks, dumbbells, and a vibrant city skyline mural.",
      "link": "",
      "alt_text": "Gym with weight racks, dumbbells, and city skyline mural.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_36a90174d548e05878a62313",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Tilikum Place Cafe",
      "poi_type": "Restaurants",
      "poi_address": "407 Cedar St, Seattle, WA 98121, USA",
      "poi_short_description": "European-style bistro and bar offering an eclectic, seasonal menu in a casual, stylish space.",
      "poi_long_description": "European-style bistro and bar offering an eclectic, seasonal menu in a casual, stylish space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-c265-73da-8a36-cdfaad546048.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-c265-73da-8a36-cdfaad546048",
        "storage_key": "property/6767906449166921/019f15b3-c265-73da-8a36-cdfaad546048.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tilikumplacecafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13320425537856526660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tilikum-place-cafe",
      "poi_latitude": "47.6179313",
      "poi_longitude": "-122.3476593",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-282-4830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TtIO08VkFQRRNn6uHOo27g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_81ba96eafd5731f62d2b2160",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "The 5 Point Cafe",
      "poi_type": "Restaurants",
      "poi_address": "415 Cedar St, Seattle, WA 98121, USA",
      "poi_short_description": "Circa-1929 American diner open 24/7 serving hearty all-day breakfasts, burgers & hot sandwiches.",
      "poi_long_description": "Circa-1929 American diner open 24/7 serving hearty all-day breakfasts, burgers & hot sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-4efc-77be-a4d0-d46437ea0c16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-4efc-77be-a4d0-d46437ea0c16",
        "storage_key": "property/6767906449166921/019cfde3-4efc-77be-a4d0-d46437ea0c16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.the5pointcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16471903945836826826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-5-point-cafe",
      "poi_latitude": "47.6180712",
      "poi_longitude": "-122.3473786",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-448-9991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibX4ME8VkFQRypD16V31l-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "ec_d7e717bdebf96eb77aff999c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Umi Sake House",
      "poi_type": "Restaurants",
      "poi_address": "2230 1st Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Sleek spot for inventive sushi rolls, izakaya-style snacks, and sake served late-night.",
      "poi_long_description": "Sleek spot for inventive sushi rolls, izakaya-style snacks, and sake served late-night.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-8bc6-7669-a8c3-591d6ad1a42a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-8bc6-7669-a8c3-591d6ad1a42a",
        "storage_key": "property/6767906449166921/01a03f58-8bc6-7669-a8c3-591d6ad1a42a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.umisakehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13654945144811541709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "umi-sake-house",
      "poi_latitude": "47.6133307",
      "poi_longitude": "-122.3460646",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-374-8717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlwUFuk0VkFQRzdTvH0McgL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_973b8df02f885166261c2e62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Shiro's Sushi",
      "poi_type": "Restaurants",
      "poi_address": "2401 2nd Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Omakase & an à la carte menu prevail in a spartan room at this prominent Belltown fixture.",
      "poi_long_description": "Omakase & an à la carte menu prevail in a spartan room at this prominent Belltown fixture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-8883-72cd-9d49-dc288928ddea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-8883-72cd-9d49-dc288928ddea",
        "storage_key": "property/6767906449166921/01a03f58-8883-72cd-9d49-dc288928ddea.webp",
        "width": 1005,
        "height": 1280
      },
      "poi_business_url": "http://shiros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12785910315054646356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shiros-sushi",
      "poi_latitude": "47.6147775",
      "poi_longitude": "-122.3474324",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-443-9844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwKffU4VkFQRVMTVWrCtcLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_5a84cda1883ad71ce4d01ff6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Serious Pie Downtown",
      "poi_type": "Restaurants",
      "poi_address": "2001 4th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Cozy restaurant with wood-fired, thin-crust gourmet pizzas, wine, and beer served at communal tables.",
      "poi_long_description": "Cozy restaurant with wood-fired, thin-crust gourmet pizzas, wine, and beer served at communal tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-c174-7399-ae15-6eca28e8b445.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-c174-7399-ae15-6eca28e8b445",
        "storage_key": "property/6767906449166921/019f15b3-c174-7399-ae15-6eca28e8b445.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seriouspieseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14996315123873928816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "serious-pie-downtown",
      "poi_latitude": "47.6130415",
      "poi_longitude": "-122.3403637",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-838-7388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSXeVvUwVkFQRcNZSuiadHdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_0983f74937c578fd65424cb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "El Gaucho Seattle",
      "poi_type": "Restaurants",
      "poi_address": "2200 Western Ave Ste. 101, Seattle, WA 98121, USA",
      "poi_short_description": "Elegant steakhouse offering a menu of high-end classics like Angus beef & seafood.",
      "poi_long_description": "Elegant steakhouse offering a menu of high-end classics like Angus beef & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-1a87-7379-86b7-5e3b51d59fb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddcc-1a87-7379-86b7-5e3b51d59fb2",
        "storage_key": "property/6767906449166921/019fddcc-1a87-7379-86b7-5e3b51d59fb2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://elgaucho.com/elgauchoseattle/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8903593617627832081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-gaucho-seattle",
      "poi_latitude": "47.6122632",
      "poi_longitude": "-122.346285",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-728-1337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XNlhkQVkFQREV8k0zjrj3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_1c56510a2f95696e506c9b55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Palace Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2030 5th Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Upscale New American food and cocktails from chef Tom Douglas in booths with intimate lighting.",
      "poi_long_description": "Upscale New American food and cocktails from chef Tom Douglas in booths with intimate lighting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-c0d0-70ca-81d3-ea2e682a903a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-c0d0-70ca-81d3-ea2e682a903a",
        "storage_key": "property/6767906449166921/019f15b3-c0d0-70ca-81d3-ea2e682a903a.webp",
        "width": 899,
        "height": 600
      },
      "poi_business_url": "https://www.palacekitchen.com/?utm_source=gbp&utm_medium=organic&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=10186076354542354153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palace-kitchen",
      "poi_latitude": "47.6145745",
      "poi_longitude": "-122.3400493",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-441-2888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkQm5kEsVkFQR6b6A73k2XI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_74967b57e6f554b7eccdf262",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "IL Bistro",
      "poi_type": "Restaurants",
      "poi_address": "93 Pike St A, Seattle, WA 98101, USA",
      "poi_short_description": "Long-running subterranean Italian trattoria with a late-night menu & an intimate, candlelit setting.",
      "poi_long_description": "Long-running subterranean Italian trattoria with a late-night menu & an intimate, candlelit setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-893c-70aa-87d8-f4de395f1927.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-893c-70aa-87d8-f4de395f1927",
        "storage_key": "property/6767906449166921/01a03f58-893c-70aa-87d8-f4de395f1927.webp",
        "width": 1242,
        "height": 699
      },
      "poi_business_url": "https://www.ilbistro.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4396607695101155488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "il-bistro",
      "poi_latitude": "47.6084952",
      "poi_longitude": "-122.3401715",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-682-3049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2kVWLJqkFQRoNhAi2fjAz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c1133a0ac3e4e779774a5798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Matt's in the Market",
      "poi_type": "Restaurants",
      "poi_address": "94 Pike St #32, Seattle, WA 98101, USA",
      "poi_short_description": "Pacific NW cuisine with seasonal specials & extensive wine options served with views of Elliott Bay.",
      "poi_long_description": "Pacific NW cuisine with seasonal specials & extensive wine options served with views of Elliott Bay.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-880d-70b2-a85c-a6cca61a9a08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-880d-70b2-a85c-a6cca61a9a08",
        "storage_key": "property/6767906449166921/01a03f58-880d-70b2-a85c-a6cca61a9a08.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "http://www.mattsinthemarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10137347102276822174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matts-in-the-market",
      "poi_latitude": "47.6089023",
      "poi_longitude": "-122.3405542",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-467-7909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6GM-bJqkFQRnqQLxHoXr4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_7282e919de14a3a0e7ebf5bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "The Pink Door",
      "poi_type": "Restaurants",
      "poi_address": "1919 Post Alley, Seattle, WA 98101, USA",
      "poi_short_description": "Italian restaurant with cabaret shows and trapeze entertainment, plus terrace with Elliott Bay views.",
      "poi_long_description": "Italian restaurant with cabaret shows and trapeze entertainment, plus terrace with Elliott Bay views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b1-0b84-73cc-925a-0209ee2963b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b1-0b84-73cc-925a-0209ee2963b6",
        "storage_key": "property/6767906449166921/019f15b1-0b84-73cc-925a-0209ee2963b6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thepinkdoor.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13451524338311652394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pink-door",
      "poi_latitude": "47.6103652",
      "poi_longitude": "-122.3425604",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-443-3241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ91YOzrJqkFQRKmSW0B1qrbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_1d5cc36edada6f5d9dbfaa17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Etta's Big Mountain BBQ",
      "poi_type": "Restaurants",
      "poi_address": "2020 Western Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Relaxed restaurant near Pike Place Market featuring BBQ plates such as brisket, pork ribs & nachos.",
      "poi_long_description": "Relaxed restaurant near Pike Place Market featuring BBQ plates such as brisket, pork ribs & nachos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-8ae8-75ab-8303-069e3ab8c621.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-8ae8-75ab-8303-069e3ab8c621",
        "storage_key": "property/6767906449166921/01a03f58-8ae8-75ab-8303-069e3ab8c621.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10985876570149271852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ettas-big-mountain-bbq",
      "poi_latitude": "47.61078999999999",
      "poi_longitude": "-122.343871",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-829-7535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxRG0N00VkFQRLLkI7oisdZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_bd7e536649ed52894f6ad3c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Pike Place Chowder - Pike Place Market",
      "poi_type": "Restaurants",
      "poi_address": "1530 Post Alley, Seattle, WA 98101, USA",
      "poi_short_description": "Local seafood place serving traditional and specialty chowders in a counter-serve setting.",
      "poi_long_description": "Local seafood place serving traditional and specialty chowders in a counter-serve setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-8acb-774d-8a86-6b6db9d934b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-8acb-774d-8a86-6b6db9d934b8",
        "storage_key": "property/6767906449166921/01a03f58-8acb-774d-8a86-6b6db9d934b8.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.pikeplacechowder.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=983461984774551847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pike-place-chowder---pike-place-market",
      "poi_latitude": "47.6094243",
      "poi_longitude": "-122.3412192",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-267-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJldHS8bJqkFQRJ3mW7Hb1pQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_0de0af773317881549df5964",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "How to Cook a Wolf",
      "poi_type": "Restaurants",
      "poi_address": "2208 Queen Anne Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Wood-paneled eatery by chef Ethan Stowell specializing in sophisticated Italian-Mediterranean fare.",
      "poi_long_description": "Wood-paneled eatery by chef Ethan Stowell specializing in sophisticated Italian-Mediterranean fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-89aa-70ea-9c9a-becca782d1f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-89aa-70ea-9c9a-becca782d1f1",
        "storage_key": "property/6767906449166921/01a03f58-89aa-70ea-9c9a-becca782d1f1.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "https://howtocookawolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18349445658929115751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "how-to-cook-a-wolf",
      "poi_latitude": "47.6387234",
      "poi_longitude": "-122.3566423",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-838-8090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-hJdxIVkFQRZ7LNdZtTpv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_3ca93df3a48b2ccf69bb7ed6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Canlis",
      "poi_type": "Restaurants",
      "poi_address": "2576 Aurora Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Landmark fine-dining destination (since 1950s) offering Pacific NW fare in a midcentury-modern home.",
      "poi_long_description": "Landmark fine-dining destination (since 1950s) offering Pacific NW fare in a midcentury-modern home.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-8cad-7609-8f15-906262640b06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-8cad-7609-8f15-906262640b06",
        "storage_key": "property/6767906449166921/01a03f58-8cad-7609-8f15-906262640b06.webp",
        "width": 1280,
        "height": 905
      },
      "poi_business_url": "https://canlis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15060210120606856902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canlis",
      "poi_latitude": "47.6430933",
      "poi_longitude": "-122.3467535",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-283-3313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRXCfNwUVkFQRxraD8U-dANE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_9ca8d9a21c28c548b1de2c88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Ivar's Acres of Clams",
      "poi_type": "Restaurants",
      "poi_address": "1001 Alaskan Wy Ste. 102, Seattle, WA 98104, USA",
      "poi_short_description": "Local chain dishing up fried fish & chowders in casual quarters with nautical accents.",
      "poi_long_description": "Local chain dishing up fried fish & chowders in casual quarters with nautical accents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-8a50-77e9-9073-7e0429ba3758.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-8a50-77e9-9073-7e0429ba3758",
        "storage_key": "property/6767906449166921/01a03f58-8a50-77e9-9073-7e0429ba3758.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.ivars.com/acres",
      "poi_directions_map_url": "https://maps.google.com/?cid=16553677074958837107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ivars-acres-of-clams",
      "poi_latitude": "47.60407619999999",
      "poi_longitude": "-122.3389838",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-624-6852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d169-717a-97c1-85def76133b1",
        "storage_key": "property/6767906449166921/019cfde3-d169-717a-97c1-85def76133b1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8xzLa5qkFQRc-VyM5h5uuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_683fdf36444b6c544630a33e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Metropolitan Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 Mercer St, Seattle, WA 98109, USA",
      "poi_short_description": "Local chain outpost of upscale supermarkets with a variety of foodstuffs, plus prepared meals.",
      "poi_long_description": "Local chain outpost of upscale supermarkets with a variety of foodstuffs, plus prepared meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-ca53-77cd-bcb3-2f7fc71633ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-ca53-77cd-bcb3-2f7fc71633ba",
        "storage_key": "property/6767906449166921/019f15b3-ca53-77cd-bcb3-2f7fc71633ba.webp",
        "width": 1280,
        "height": 990
      },
      "poi_business_url": "https://www.metropolitan-market.com/locations/queen-anne",
      "poi_directions_map_url": "https://maps.google.com/?cid=15107838454557967876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metropolitan-market",
      "poi_latitude": "47.6247988",
      "poi_longitude": "-122.3548324",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 206-213-0778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d170-770d-8088-88155c0d2342",
        "storage_key": "property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsY2q3UMVkFQRBAbqlwfTqdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_f35ff56e9d2d1c9df05118bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "QFC",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 Mercer St, Seattle, WA 98109, USA",
      "poi_short_description": "Supermarket chain selling typical groceries & produce, plus homeware & electronics.",
      "poi_long_description": "Supermarket chain selling typical groceries & produce, plus homeware & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-ca5d-76c8-95d5-9e70ee6c93ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-ca5d-76c8-95d5-9e70ee6c93ca",
        "storage_key": "property/6767906449166921/019f15b3-ca5d-76c8-95d5-9e70ee6c93ca.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.qfc.com/stores/grocery/wa/seattle/uptown/705/00881?cid=loc_70500881_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13440610371067915383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qfc",
      "poi_latitude": "47.62502689999999",
      "poi_longitude": "-122.3471738",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 206-352-4020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d170-770d-8088-88155c0d2342",
        "storage_key": "property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-cPR0cVkFQRdyzvy-ujhro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_685b9f8f1188040155ca7b62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2210 Westlake Ave N, Seattle, WA 98121, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b1-0b97-7112-9076-f0b3fb4648d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b1-0b97-7112-9076-f0b3fb4648d7",
        "storage_key": "property/6767906449166921/019f15b1-0b97-7112-9076-f0b3fb4648d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/westlake?utm_source=google&utm_medium=organic&utm_campaign=listings&ref_=US_TRF_ALL_UFG_WFM_FRSOC_1001768",
      "poi_directions_map_url": "https://maps.google.com/?cid=13331991485400734650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.6183573",
      "poi_longitude": "-122.3380162",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-621-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d170-770d-8088-88155c0d2342",
        "storage_key": "property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyz9g9EkVkFQRutvXu56_BLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_e06af2e4b214c139a14192b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "503 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-9165-7297-96b3-b589759a8fe4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-9165-7297-96b3-b589759a8fe4",
        "storage_key": "property/6767906449166921/01a03f58-9165-7297-96b3-b589759a8fe4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/seattle-wa-pharmacies/503-westlake-ave-n-seattle-wa-98109/storeid=11076?WT.mc_id=LS_GOOGLE_RX_11076",
      "poi_directions_map_url": "https://maps.google.com/?cid=7590490931773551987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "47.6233739",
      "poi_longitude": "-122.3388013",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-505-2330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d16c-7714-a7f4-556fcb328123.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d16c-7714-a7f4-556fcb328123",
        "storage_key": "property/6767906449166921/019cfde3-d16c-7714-a7f4-556fcb328123.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZUDj_UVkFQRc7UvS0nXVmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_e356713ebeb45df60e2e9a64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "951 Mercer St, Seattle, WA 98109, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-ccf0-77f8-9e0b-c2906d74d25a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-ccf0-77f8-9e0b-c2906d74d25a",
        "storage_key": "property/6767906449166921/019f15b3-ccf0-77f8-9e0b-c2906d74d25a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-951+mercer+st-seattle-wa-98109/id=21452",
      "poi_directions_map_url": "https://maps.google.com/?cid=8774373187664277877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "47.6243732",
      "poi_longitude": "-122.338026",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-701-2262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_WYYXskVkFQRdfFw8ezVxHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_0f3c6775c32aed66ffd59633",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Broadway Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "417 Broadway E, Seattle, WA 98102, USA",
      "poi_short_description": "Contemporary shopping complex featuring a large supermarket, cafe, a clothing store & services.",
      "poi_long_description": "Contemporary shopping complex featuring a large supermarket, cafe, a clothing store & services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-944d-755a-bc45-518bc711e638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-944d-755a-bc45-518bc711e638",
        "storage_key": "property/6767906449166921/01a03f58-944d-755a-bc45-518bc711e638.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.regencycenters.com/property/detail/60738/Broadway-Market",
      "poi_directions_map_url": "https://maps.google.com/?cid=839564708106742487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broadway-market",
      "poi_latitude": "47.6224556",
      "poi_longitude": "-122.3213064",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 425-677-2276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3b03-70bd-99c4-7058c1f8e104.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3b03-70bd-99c4-7058c1f8e104",
        "storage_key": "property/6767906449166921/019cfde4-3b03-70bd-99c4-7058c1f8e104.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8xcf4C0VkFQR1yqoYKe7pgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_0bfcc0f44268c8410d0d6155",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Ken's Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 6th Ave W, Seattle, WA 98119, USA",
      "poi_short_description": "Family-run grocer with all the essentials, plus chef-made takeout, an espresso bar, wine & flowers.",
      "poi_long_description": "Family-run grocer with all the essentials, plus chef-made takeout, an espresso bar, wine & flowers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-93c7-7719-9450-4f09773d42cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-93c7-7719-9450-4f09773d42cb",
        "storage_key": "property/6767906449166921/01a03f58-93c7-7719-9450-4f09773d42cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kens-qa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9649577922800682536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kens-market",
      "poi_latitude": "47.6397333",
      "poi_longitude": "-122.3647222",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-282-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d170-770d-8088-88155c0d2342",
        "storage_key": "property/6767906449166921/019cfde3-d170-770d-8088-88155c0d2342.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0EfLHMVkFQRKIb8wP4v6oU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_2c58f382e3115cff1828d4f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "The Bodega South Lake Union",
      "poi_type": "Restaurants",
      "poi_address": "709 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-200e-72ed-a133-3e749abf65f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddcc-200e-72ed-a133-3e749abf65f9",
        "storage_key": "property/6767906449166921/019fddcc-200e-72ed-a133-3e749abf65f9.webp",
        "width": 1024,
        "height": 1024
      },
      "poi_business_url": "https://www.the-bodega.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6172355384734950633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bodega-south-lake-union",
      "poi_latitude": "47.6259561",
      "poi_longitude": "-122.3391224",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-432-9064",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3b03-70bd-99c4-7058c1f8e104.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3b03-70bd-99c4-7058c1f8e104",
        "storage_key": "property/6767906449166921/019cfde4-3b03-70bd-99c4-7058c1f8e104.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6-x8nYEVkFQR6aSYFoWcqFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "ec_c944d14f9f95537272e2e5c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "The UPS Store",
      "poi_type": "Major Employers & Offices",
      "poi_address": "24 Roy St, Seattle, WA 98109, USA",
      "poi_short_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_long_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-90d4-7079-977c-2e6f4361a96f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-90d4-7079-977c-2e6f4361a96f",
        "storage_key": "property/6767906449166921/01a03f58-90d4-7079-977c-2e6f4361a96f.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://locations.theupsstore.com/wa/seattle/24-roy-st?utm_source=Yext&utm_medium=organic&utm_campaign=Listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=17645997213442513978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ups-store",
      "poi_latitude": "47.6255927",
      "poi_longitude": "-122.3556445",
      "poi_miles_from_property": "184 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 206-282-2888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYw0fkEVkFQROhzGHvks4_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shipping_service"
    },
    {
      "id": "ec_e9cfa4da364135a70481b0d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Westlake Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "400 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "4-story, glass-enclosed retail center for shopping & dining with a food court.",
      "poi_long_description": "4-story, glass-enclosed retail center for shopping & dining with a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-914d-7556-ba21-57cac29787d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-914d-7556-ba21-57cac29787d8",
        "storage_key": "property/6767906449166921/01a03f58-914d-7556-ba21-57cac29787d8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.westlakecenter.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=878541090116204128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westlake-center",
      "poi_latitude": "47.6120485",
      "poi_longitude": "-122.3374325",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-467-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde4-3b03-70bd-99c4-7058c1f8e104.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3b03-70bd-99c4-7058c1f8e104",
        "storage_key": "property/6767906449166921/019cfde4-3b03-70bd-99c4-7058c1f8e104.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5YbCpbRqkFQRYPb1fHc0MQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_69fd31e214b4317975b07d26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "John Hay Elementary School",
      "poi_type": "Education",
      "poi_address": "201 Garfield St, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-254c-73d8-b986-1d901110d722.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddcc-254c-73d8-b986-1d901110d722",
        "storage_key": "property/6767906449166921/019fddcc-254c-73d8-b986-1d901110d722.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hayes.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5874759900747356384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-hay-elementary-school",
      "poi_latitude": "47.6328489",
      "poi_longitude": "-122.3522135",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-252-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ32PP-hQVkFQR4FjBAAFXh1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1e5cf386dc0c0c59ddd3fa45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "McClure Middle School",
      "poi_type": "Education",
      "poi_address": "1915 1st Ave W, Seattle, WA 98119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-d1f0-7431-8498-d35ec72719c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-d1f0-7431-8498-d35ec72719c9",
        "storage_key": "property/6767906449166921/019f15b3-d1f0-7431-8498-d35ec72719c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mcclurems.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13322774541261369370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcclure-middle-school",
      "poi_latitude": "47.6367366",
      "poi_longitude": "-122.3589594",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-252-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfzWuKRMVkFQRGnCAstsA5Lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_6a7b9dc58f8b8fb481f8dd3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "The Center School",
      "poi_type": "Education",
      "poi_address": "305 Harrison St, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-7b84-738c-a718-3fe25f28f9c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-7b84-738c-a718-3fe25f28f9c8",
        "storage_key": "property/6767906449166921/019cfde3-7b84-738c-a718-3fe25f28f9c8.webp",
        "width": 514,
        "height": 289
      },
      "poi_business_url": "http://centerhs.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10616781482920686994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-center-school",
      "poi_latitude": "47.6219351",
      "poi_longitude": "-122.3513682",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-252-9850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsQLp1UUVkFQRkrVuM4JiVpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_57f1f5fd7dd91cce6cee9bd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Lincoln High School",
      "poi_type": "Education",
      "poi_address": "4400 Interlake Ave N, Seattle, WA 98103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://lincolnhs.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17228578893376073271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-high-school",
      "poi_latitude": "47.65995100000001",
      "poi_longitude": "-122.3398855",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-413-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn9R6x1YUkFQRNy55_Dg1GO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_bdcdb5a4f32c07f5cc60f034",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Seattle Pacific University",
      "poi_type": "Education",
      "poi_address": "3307 3rd Ave W, Seattle, WA 98119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-8698-7475-b9ba-e453a1002f1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-8698-7475-b9ba-e453a1002f1c",
        "storage_key": "property/6767906449166921/019cfde3-8698-7475-b9ba-e453a1002f1c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://spu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11147637703534498643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-pacific-university",
      "poi_latitude": "47.6491714",
      "poi_longitude": "-122.3618554",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-281-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlXOYeKcVkFQRU9Psu21dtJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_9cc6594ddd17628388bbda68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Cornish College of the Arts at Seattle University",
      "poi_type": "Education",
      "poi_address": "1000 Lenora St, Seattle, WA 98121, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-978d-7328-830d-8012fbaed313.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-978d-7328-830d-8012fbaed313",
        "storage_key": "property/6767906449166921/01a03f58-978d-7328-830d-8012fbaed313.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cornish.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16527929581452341339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cornish-college-of-the-arts-at-seattle-university",
      "poi_latitude": "47.6181961",
      "poi_longitude": "-122.3362411",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-296-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQaIjBzYVkFQRWzAjt2IAX-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_f9173f287baef880a60813fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Kiddie Academy of Seattle at Queen Anne",
      "poi_type": "Education",
      "poi_address": "601 Valley St, Seattle, WA 98109, USA",
      "poi_short_description": "Educational day care center featuring age-specific child care programs and an outdoor playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-d557-746d-8e6c-bcb648e0f57e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-d557-746d-8e6c-bcb648e0f57e",
        "storage_key": "property/6767906449166921/019f15b3-d557-746d-8e6c-bcb648e0f57e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kiddieacademy.com/academies/seattle-at-queen-anne/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11731485431512194452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiddie-academy-of-seattle-at-queen-anne",
      "poi_latitude": "47.6259758",
      "poi_longitude": "-122.3447543",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-886-3999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvVEDtjgVkFQRlF30CNibzqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_e05c7b1ca497967e5596d40a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Kidspace Childcare Center",
      "poi_type": "Education",
      "poi_address": "3837 13th Ave W #200, Seattle, WA 98119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-9859-7638-944c-54451140a673.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-9859-7638-944c-54451140a673",
        "storage_key": "property/6767906449166921/01a03f58-9859-7638-944c-54451140a673.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kidspaceseattle.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10090557897817556218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kidspace-childcare-center",
      "poi_latitude": "47.6549776",
      "poi_longitude": "-122.3738032",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-282-3622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqdxVqKQVkFQR-oTtLPLcCIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_b373267f9c0fb92030db3427",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "The Goddard School of North Queen Anne",
      "poi_type": "Education",
      "poi_address": "310 Florentia St, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-9835-762b-ab0f-00038cc5c0e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-9835-762b-ab0f-00038cc5c0e6",
        "storage_key": "property/6767906449166921/01a03f58-9835-762b-ab0f-00038cc5c0e6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.goddardschool.com/schools/wa/seattle/north-queen-anne?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=8797338301594061425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-north-queen-anne",
      "poi_latitude": "47.647093",
      "poi_longitude": "-122.3507171",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-881-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6edDYWwVkFQRccpzM5NsFno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_29b25517d7808f10d439fc52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Space Needle",
      "poi_type": "Entertainment",
      "poi_address": "400 Broad St, Seattle, WA 98109, USA",
      "poi_short_description": "Iconic, 605-ft-tall spire at the Seattle Center, with an observation deck & a rotating restaurant.",
      "poi_long_description": "Iconic, 605-ft-tall spire at the Seattle Center, with an observation deck & a rotating restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-e027-77b8-a4de-bc50800e9adb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-e027-77b8-a4de-bc50800e9adb",
        "storage_key": "property/6767906449166921/019f15b3-e027-77b8-a4de-bc50800e9adb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.spaceneedle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15792901685599310349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "space-needle",
      "poi_latitude": "47.6205063",
      "poi_longitude": "-122.3492774",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-905-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-bfVTh8VkFQRDZLQnmioK9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "observation_deck"
    },
    {
      "id": "ec_8178066ed5416f06803fa447",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Museum of Pop Culture",
      "poi_type": "Entertainment",
      "poi_address": "325 5th Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Inspired by Jimi Hendrix, the museum includes items from icons ranging from Bo Diddley to Bob Dylan.",
      "poi_long_description": "Inspired by Jimi Hendrix, the museum includes items from icons ranging from Bo Diddley to Bob Dylan.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-d5a4-711b-9ff6-358ae24f59d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-d5a4-711b-9ff6-358ae24f59d7",
        "storage_key": "property/6767906449166921/019f15b3-d5a4-711b-9ff6-358ae24f59d7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mopop.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15125666784235608082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-pop-culture",
      "poi_latitude": "47.6214824",
      "poi_longitude": "-122.3481245",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-770-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d533-773d-a5b6-a5e5771c7548.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d533-773d-a5b6-a5e5771c7548",
        "storage_key": "property/6767906449166921/019cfde3-d533-773d-a5b6-a5e5771c7548.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8p6-EYVkFQREthJEc0p6dE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_7485e0babe144c12cc5e10b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Chihuly Garden and Glass",
      "poi_type": "Entertainment",
      "poi_address": "305 Harrison St, Seattle, WA 98109, USA",
      "poi_short_description": "Art museum & sculpture garden showcasing Dale Chihuly's large, colorful glass works.",
      "poi_long_description": "Art museum & sculpture garden showcasing Dale Chihuly's large, colorful glass works.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-d53b-7325-ab91-d3c7144465aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-d53b-7325-ab91-d3c7144465aa",
        "storage_key": "property/6767906449166921/019f15b3-d53b-7325-ab91-d3c7144465aa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chihulygardenandglass.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8881620907110491783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chihuly-garden-and-glass",
      "poi_latitude": "47.6205599",
      "poi_longitude": "-122.3504476",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-753-4940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d533-773d-a5b6-a5e5771c7548.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d533-773d-a5b6-a5e5771c7548",
        "storage_key": "property/6767906449166921/019cfde3-d533-773d-a5b6-a5e5771c7548.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTtr1kUVkFQRh-YAfijbQXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_b2a05e2c7257d33da78cd900",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Pacific Science Center",
      "poi_type": "Entertainment",
      "poi_address": "200 Sue Bird Ct N, Seattle, WA 98109, USA",
      "poi_short_description": "Rotating science exhibits plus laser light shows, a tropical butterfly house & IMAX movie theaters.",
      "poi_long_description": "Rotating science exhibits plus laser light shows, a tropical butterfly house & IMAX movie theaters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-8d1b-74e8-b405-1ed7938e1419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-8d1b-74e8-b405-1ed7938e1419",
        "storage_key": "property/6767906449166921/019cfde3-8d1b-74e8-b405-1ed7938e1419.webp",
        "width": 651,
        "height": 651
      },
      "poi_business_url": "https://www.pacificsciencecenter.org/?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072473183036697406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pacific-science-center",
      "poi_latitude": "47.6200033",
      "poi_longitude": "-122.3515819",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-443-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d533-773d-a5b6-a5e5771c7548.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d533-773d-a5b6-a5e5771c7548",
        "storage_key": "property/6767906449166921/019cfde3-d533-773d-a5b6-a5e5771c7548.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxZWvUwVkFQRPuvwC7JTqZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_55020ebf69c3cbb3929d4479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Climate Pledge Arena",
      "poi_type": "Entertainment",
      "poi_address": "334 1st Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Large venue hosts WNBA & NCAA basketball, roller derby, concerts & events for up to 17,000 people.",
      "poi_long_description": "Large venue hosts WNBA & NCAA basketball, roller derby, concerts & events for up to 17,000 people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b1-167a-745d-938a-616e6101e0b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b1-167a-745d-938a-616e6101e0b3",
        "storage_key": "property/6767906449166921/019f15b1-167a-745d-938a-616e6101e0b3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://climatepledgearena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15998104634649095719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "climate-pledge-arena",
      "poi_latitude": "47.622094",
      "poi_longitude": "-122.353984",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-752-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ046-cUQVkFQRJy7KU2evBN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_cc7ae8ddf293b7119b0e241f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "SIFF Film Center",
      "poi_type": "Entertainment",
      "poi_address": "167 Republican St, Seattle, WA 98109, USA",
      "poi_short_description": "State-of-the-art movie theater on the Seattle Center campus showing arthouse films.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-9b64-700c-831f-9e54b2c925d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-9b64-700c-831f-9e54b2c925d1",
        "storage_key": "property/6767906449166921/01a03f58-9b64-700c-831f-9e54b2c925d1.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://www.siff.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3219943379949209010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "siff-film-center",
      "poi_latitude": "47.6230416",
      "poi_longitude": "-122.3532494",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 206-464-5830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-cfeb-73eb-bde4-f57e642d98b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f58-cfeb-73eb-bde4-f57e642d98b7",
        "storage_key": "property/6767906449166921/01a03f58-cfeb-73eb-bde4-f57e642d98b7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJFXwxG0QVkFQRskW-rnGJryw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_25fc6648985870c4f72b3e5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "SIFF Cinema Uptown",
      "poi_type": "Entertainment",
      "poi_address": "511 Queen Anne Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Fans of classics, indie & foreign films favor this movie theater, which also stages special events.",
      "poi_long_description": "Fans of classics, indie & foreign films favor this movie theater, which also stages special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-9b47-7278-bda2-6a5471974b5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-9b47-7278-bda2-6a5471974b5d",
        "storage_key": "property/6767906449166921/01a03f58-9b47-7278-bda2-6a5471974b5d.webp",
        "width": 1280,
        "height": 746
      },
      "poi_business_url": "https://www.siff.net/year-round-cinema/cinema-venues/siff-cinema-uptown",
      "poi_directions_map_url": "https://maps.google.com/?cid=7412349450857711398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "siff-cinema-uptown",
      "poi_latitude": "47.62352",
      "poi_longitude": "-122.3571569",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-464-5830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-cfeb-73eb-bde4-f57e642d98b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03f58-cfeb-73eb-bde4-f57e642d98b7",
        "storage_key": "property/6767906449166921/01a03f58-cfeb-73eb-bde4-f57e642d98b7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_9Uf00YVkFQRJodvoY303WY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_b0bb43e5663b722117a2f73c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Seattle Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "305 Harrison St, Seattle, WA 98109, USA",
      "poi_short_description": "Basement area of Seattle Center with hands-on cultural exhibits geared toward children 10 & under.",
      "poi_long_description": "Basement area of Seattle Center with hands-on cultural exhibits geared toward children 10 & under.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-d835-74e1-9406-00caec02c666.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-d835-74e1-9406-00caec02c666",
        "storage_key": "property/6767906449166921/019f15b3-d835-74e1-9406-00caec02c666.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://seattlechildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4808373583600415459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-childrens-museum",
      "poi_latitude": "47.621394",
      "poi_longitude": "-122.350884",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-441-1768",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d533-773d-a5b6-a5e5771c7548.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d533-773d-a5b6-a5e5771c7548",
        "storage_key": "property/6767906449166921/019cfde3-d533-773d-a5b6-a5e5771c7548.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJsQLp1UUVkFQR4_LfZUzGukI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_7103b1a271d5a03575ec99f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "The Crocodile",
      "poi_type": "Entertainment",
      "poi_address": "2505 1st Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Live music venue & bar presents diverse local & national bands in a low-key, causal setting.",
      "poi_long_description": "Live music venue & bar presents diverse local & national bands in a low-key, causal setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-dd80-721a-b323-cbe404a7ccfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-dd80-721a-b323-cbe404a7ccfc",
        "storage_key": "property/6767906449166921/019f15b3-dd80-721a-b323-cbe404a7ccfc.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.thecrocodile.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9152732140488888689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-crocodile",
      "poi_latitude": "47.61476769999999",
      "poi_longitude": "-122.3492781",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-420-6351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0kh2WcVkFQRcREkdmMJBX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_f67c7aa555a6e02b36ba4009",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Paramount Theatre",
      "poi_type": "Entertainment",
      "poi_address": "911 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Historic performing arts venue that hosts major musicals, plus big-name music & comedy acts.",
      "poi_long_description": "Historic performing arts venue that hosts major musicals, plus big-name music & comedy acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-deb9-7747-aa2c-96cc568f7314.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-deb9-7747-aa2c-96cc568f7314",
        "storage_key": "property/6767906449166921/019f15b3-deb9-7747-aa2c-96cc568f7314.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "http://www.stgpresents.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7759253808531622023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paramount-theatre",
      "poi_latitude": "47.6135244",
      "poi_longitude": "-122.3315134",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-682-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWjwULVqkFQRh8ifgzporms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_6ea26ad7d78494aa90f729c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Harborview Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "325 9th Ave Main Hospital, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-97d5-7264-aa8a-33860e0a8e48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-97d5-7264-aa8a-33860e0a8e48",
        "storage_key": "property/6767906449166921/019cfde3-97d5-7264-aa8a-33860e0a8e48.webp",
        "width": 1279,
        "height": 903
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/harborview-medical-center?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDM0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6803544737971406536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harborview-medical-center",
      "poi_latitude": "47.6039167",
      "poi_longitude": "-122.323905",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-744-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d555-773c-9cd4-25a192d54a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d555-773c-9cd4-25a192d54a59",
        "storage_key": "property/6767906449166921/019cfde3-d555-773c-9cd4-25a192d54a59.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7w3EijcVkFQRyIZDeOQLa14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_345353c7d52bfaa24389d8d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Swedish Hospital - First Hill Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "747 Broadway, Seattle, WA 98122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-f142-763e-9fda-ab173c569233.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-f142-763e-9fda-ab173c569233",
        "storage_key": "property/6767906449166921/019f15b3-f142-763e-9fda-ab173c569233.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.swedish.org/locations/first-hill-campus?Is=location&y_source=1_OTU3NjkyMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5633867081434861685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swedish-hospital---first-hill-campus",
      "poi_latitude": "47.608469",
      "poi_longitude": "-122.321481",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-386-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d555-773c-9cd4-25a192d54a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d555-773c-9cd4-25a192d54a59",
        "storage_key": "property/6767906449166921/019cfde3-d555-773c-9cd4-25a192d54a59.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9fNUchqkFQRdRCx1EKEL04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_aed350a77ae10b335e7d9903",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "ZoomCare Queen Anne Seattle - Urgent Care & Primary Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1909 Queen Anne Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-9f42-7029-bc39-654a634d793a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-9f42-7029-bc39-654a634d793a",
        "storage_key": "property/6767906449166921/01a03f58-9f42-7029-bc39-654a634d793a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.zoomcare.com/clinic/zoomcare-queen-anne?utm_campaign=gmb-site&utm_source=google&utm_medium=maps&utm_content=queen-anne",
      "poi_directions_map_url": "https://maps.google.com/?cid=5544261671712153669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zoomcare-queen-anne-seattle---urgent-care--primary-care",
      "poi_latitude": "47.636352",
      "poi_longitude": "-122.3573876",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 844-966-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg-UbHxMVkFQRRWA3nJ0s8Uw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_af2921e00c7191055be1ecd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "531 Queen Anne Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-c977-734b-8001-55f850e28db2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-c977-734b-8001-55f850e28db2",
        "storage_key": "property/6767906449166921/01a03f58-c977-734b-8001-55f850e28db2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/seattle-wa-pharmacies/531-queen-anne-avenue-north-seattle-wa-98109/storeid=10331?WT.mc_id=LS_GOOGLE_FS_10331",
      "poi_directions_map_url": "https://maps.google.com/?cid=17538027588468215801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "47.6243004",
      "poi_longitude": "-122.3570503",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 206-284-7286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcoBvEMVkFQR-Q-m1yuXY_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_9813a8e2821b8d229d8a3e3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Safeway Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2100 Queen Anne Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-9d6b-70a3-b25b-7594990a2369.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-9d6b-70a3-b25b-7594990a2369",
        "storage_key": "property/6767906449166921/019cfde3-9d6b-70a3-b25b-7594990a2369.webp",
        "width": 586,
        "height": 330
      },
      "poi_business_url": "https://local.pharmacy.safeway.com/safeway/wa/seattle/2100-queen-anne-ave-n.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2644726990437476482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway-pharmacy",
      "poi_latitude": "47.6382979",
      "poi_longitude": "-122.3572925",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-316-4030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d16c-7714-a7f4-556fcb328123.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d16c-7714-a7f4-556fcb328123",
        "storage_key": "property/6767906449166921/019cfde3-d16c-7714-a7f4-556fcb328123.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVzkaBa8VkFQRgujpeC_1syQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_c944d0634ef62df4ebd6d81b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "[solidcore] Queen Anne",
      "poi_type": "Health and Wellness",
      "poi_address": "203 Roy St, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b1-1e2f-76ad-b7ca-ab070eedc6a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b1-1e2f-76ad-b7ca-ab070eedc6a7",
        "storage_key": "property/6767906449166921/019f15b1-1e2f-76ad-b7ca-ab070eedc6a7.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://solidcore.co/studios/queen-anne?siteId=5723430&locationId=2&utm_source=google&utm_medium=search&utm_content=local-listing&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15024928392084636686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "solidcore-queen-anne",
      "poi_latitude": "47.6253362",
      "poi_longitude": "-122.3524662",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 206-594-2458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8cCn2BgVkFQRDsTiYcREg9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_7e7c478c20a8642adff33d10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Ahimsa Yoga & Pilates Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "1629 Queen Anne Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-a0e3-714e-b23a-ab30da9bd272.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-a0e3-714e-b23a-ab30da9bd272",
        "storage_key": "property/6767906449166921/01a03f58-a0e3-714e-b23a-ab30da9bd272.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ahimsaseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16129842125504747309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ahimsa-yoga--pilates-studio",
      "poi_latitude": "47.63446889999999",
      "poi_longitude": "-122.3573654",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-818-0657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_0NtmcoVkFQRLZfXHfS12N8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_ebd17c5e18c4ff8a16832e60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Seattle Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2020 Western Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Roomy, family-friendly, clean gym featuring personal training, workout classes, martial arts, a squash court and a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-a0ad-779e-bbd7-4671a67f1e92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-a0ad-779e-bbd7-4671a67f1e92",
        "storage_key": "property/6767906449166921/01a03f58-a0ad-779e-bbd7-4671a67f1e92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sacdt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15505384259768133388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-athletic-club",
      "poi_latitude": "47.6108818",
      "poi_longitude": "-122.3439702",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-443-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxRG0N00VkFQRDKdpTdUwLtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_4212e7772be4460e6c15e2c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Downtown Seattle YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "909 4th Ave, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-dfd1-721d-a456-0e31c69dfc52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-dfd1-721d-a456-0e31c69dfc52",
        "storage_key": "property/6767906449166921/019f15b3-dfd1-721d-a456-0e31c69dfc52.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.seattleymca.org/locations/downtown-seattle-ymca?y_source=1_MTAzMDUwMTk3OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2731078455833288186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-seattle-ymca",
      "poi_latitude": "47.6056412",
      "poi_longitude": "-122.3327152",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-382-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ56kw4LBqkFQR-l2qvWK95iU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_bad1b61240c12dd82b166e7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2310 5th Ave #3, Seattle, WA 98121, USA",
      "poi_short_description": "Group-based gym featuring strength-training workouts, plus cardio machines.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-e3bb-7059-99b0-2fd69e830d34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-e3bb-7059-99b0-2fd69e830d34",
        "storage_key": "property/6767906449166921/019f15b3-e3bb-7059-99b0-2fd69e830d34.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/seattle-washington-0580?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=9056574650186349697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "47.61633639999999",
      "poi_longitude": "-122.3432044",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-855-5089",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4N9VkkVkFQRgTwqGqlqr30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_22234aa921cafd1cd4c36eca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Denny Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Dexter Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Park's 4 acres is home to the central offices of the Parks Department, flowers, paths & a play area.",
      "poi_long_description": "Park's 4 acres is home to the central offices of the Parks Department, flowers, paths & a play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-e665-7164-a621-d273d64614e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-e665-7164-a621-d273d64614e3",
        "storage_key": "property/6767906449166921/019f15b3-e665-7164-a621-d273d64614e3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/denny-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17697390754654843374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denny-park",
      "poi_latitude": "47.619053",
      "poi_longitude": "-122.340936",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7cLUtUkVkFQR7vF7ZiDDmfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_cb5fa39602157b46e1438887",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Counterbalance Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "700 Queen Anne Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Paved urban area named for the former trolley, with benches for gathering & light shows at night.",
      "poi_long_description": "Paved urban area named for the former trolley, with benches for gathering & light shows at night.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-a352-76ab-89d4-4512d76a265b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-a352-76ab-89d4-4512d76a265b",
        "storage_key": "property/6767906449166921/01a03f58-a352-76ab-89d4-4512d76a265b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/counterbalance-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7782068790202478599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "counterbalance-park",
      "poi_latitude": "47.6256883",
      "poi_longitude": "-122.3564248",
      "poi_miles_from_property": "377 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1z1_K0IVkFQRBzCsYVV2_2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_605fa9e21d6c5e6a7a87410f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Kinnear Place",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "799 Queen Anne Ave N, Seattle, WA 98119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-a429-7590-8d04-6d7ae2e0f090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-a429-7590-8d04-6d7ae2e0f090",
        "storage_key": "property/6767906449166921/01a03f58-a429-7590-8d04-6d7ae2e0f090.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/kinnear-place",
      "poi_directions_map_url": "https://maps.google.com/?cid=1796226625577244322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kinnear-place",
      "poi_latitude": "47.6260449",
      "poi_longitude": "-122.3568808",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9UFxJkIVkFQRolahYZl67Rg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_ac100a0cd7059a090efb6b4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Olympic Sculpture Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2901 Western Ave, Seattle, WA 98121, USA",
      "poi_short_description": "An offshoot of the Seattle Art Museum, this park features numerous sculptures spread over 9 acres.",
      "poi_long_description": "An offshoot of the Seattle Art Museum, this park features numerous sculptures spread over 9 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b1-2375-757c-bbf6-3128d4cd72b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b1-2375-757c-bbf6-3128d4cd72b5",
        "storage_key": "property/6767906449166921/019f15b1-2375-757c-bbf6-3128d4cd72b5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.seattleartmuseum.org/visit/olympic-sculpture-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8934295156938678169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olympic-sculpture-park",
      "poi_latitude": "47.6166028",
      "poi_longitude": "-122.3553167",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-654-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc88dJ1AVkFQRmZ_S-xv-_Hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a65c8bc1570e612f03b6cdb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Myrtle Edwards Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3130 Alaskan Way, Seattle, WA 98121, USA",
      "poi_short_description": "Waterfront recreation area with bike & pedestrian paths, plus an adjacent sculpture park.",
      "poi_long_description": "Waterfront recreation area with bike & pedestrian paths, plus an adjacent sculpture park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-3e13-718f-979c-5f406c21489a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddcc-3e13-718f-979c-5f406c21489a",
        "storage_key": "property/6767906449166921/019fddcc-3e13-718f-979c-5f406c21489a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/myrtle-edwards-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13640186970880608794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "myrtle-edwards-park",
      "poi_latitude": "47.6194597",
      "poi_longitude": "-122.3619153",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yjQRVwVkFQRGgpA_cetS70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_0b6a126b7d66b0564a5e5235",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Lake Union Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "860 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "12-acre lakefront park with boat launch, model-boat pond, Center for Wooden Boats & spray features.",
      "poi_long_description": "12-acre lakefront park with boat launch, model-boat pond, Center for Wooden Boats & spray features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-3ab1-742c-bebb-9a131b151165.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddcc-3ab1-742c-bebb-9a131b151165",
        "storage_key": "property/6767906449166921/019fddcc-3ab1-742c-bebb-9a131b151165.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/lake-union-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021986494381383037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-union-park",
      "poi_latitude": "47.6277112",
      "poi_longitude": "-122.3368686",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbpC3DsVkFQRfV3tymwamMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_04ab1a81e7c351b1cf308ab8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Gas Works Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2101 N Northlake Way, Seattle, WA 98103, USA",
      "poi_short_description": "Former site of an oil plant is now a 20-acre park with picnic facilities & dramatic city views.",
      "poi_long_description": "Former site of an oil plant is now a 20-acre park with picnic facilities & dramatic city views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b1-2028-73dd-9e7a-ae9186641f9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b1-2028-73dd-9e7a-ae9186641f9f",
        "storage_key": "property/6767906449166921/019f15b1-2028-73dd-9e7a-ae9186641f9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/gas-works-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2192784265468010902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gas-works-park",
      "poi_latitude": "47.6456308",
      "poi_longitude": "-122.3343532",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7BbsgIVkFQRlmFJ7KtVbh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_327f22c29c9c9fa2ca78bb6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Kerry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "211 W Highland Dr, Seattle, WA 98119, USA",
      "poi_short_description": "Panoramic views of Downtown & the Space Needle draw visitors to this small neighborhood park.",
      "poi_long_description": "Panoramic views of Downtown & the Space Needle draw visitors to this small neighborhood park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b1-1fea-73eb-94fa-86295c0860d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b1-1fea-73eb-94fa-86295c0860d9",
        "storage_key": "property/6767906449166921/019f15b1-1fea-73eb-94fa-86295c0860d9.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.seattle.gov/parks/find/parks/kerry-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3744576093846549902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kerry-park",
      "poi_latitude": "47.6294692",
      "poi_longitude": "-122.3599224",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUS2ELmoVkFQRjrUkJB5o9zM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_39c15e2703ed7b2d902b3932",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Bell Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "340 Bell St #98121, Seattle, WA 98121, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-a6c6-760b-813e-9250292c31d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-a6c6-760b-813e-9250292c31d2",
        "storage_key": "property/6767906449166921/01a03f58-a6c6-760b-813e-9250292c31d2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/bell-street-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9589294599024961341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell-street-park",
      "poi_latitude": "47.61531069999999",
      "poi_longitude": "-122.3440829",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5feGMEwVkFQRPWd0raEEFIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_18f3940f1f25968a027a7f4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Belltown Cottage Park & P-Patch",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2512 Elliott Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Local park featuring 3 historic cottages surrounded by gardens, green space & a fountain.",
      "poi_long_description": "Local park featuring 3 historic cottages surrounded by gardens, green space & a fountain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-e577-710f-a307-87ba1671ee92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-e577-710f-a307-87ba1671ee92",
        "storage_key": "property/6767906449166921/019f15b3-e577-710f-a307-87ba1671ee92.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/belltown-cottage-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16722673367583781954&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belltown-cottage-park--p-patch",
      "poi_latitude": "47.6139351",
      "poi_longitude": "-122.3509091",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d82d-712b-9a2c-4851c430fa56",
        "storage_key": "property/6767906449166921/019cfde3-d82d-712b-9a2c-4851c430fa56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJybxr_FEVkFQRQnS3ydPeEug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_993987eb660e3bc33faacda1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Westlake Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4th Ave, Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Monorail station with marble floors, multiple colorful, tiled murals & an old-school clock.",
      "poi_long_description": "Monorail station with marble floors, multiple colorful, tiled murals & an old-school clock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-eb3c-72a9-b2a3-20db72eded88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-eb3c-72a9-b2a3-20db72eded88",
        "storage_key": "property/6767906449166921/019f15b3-eb3c-72a9-b2a3-20db72eded88.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.seattlemonorail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14068683656837464517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westlake-center",
      "poi_latitude": "47.6120708",
      "poi_longitude": "-122.3369693",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-502a-703f-8f12-599650fb25c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddcc-502a-703f-8f12-599650fb25c1",
        "storage_key": "property/6767906449166921/019fddcc-502a-703f-8f12-599650fb25c1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWm2x7RqkFQRxQEkLz8BPsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_4cd3c94136a13cb4dc6287eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Seattle Center Monorail",
      "poi_type": "Transportation & Transit",
      "poi_address": "370 Thomas St, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-e944-7378-a13a-732591f38ec2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-e944-7378-a13a-732591f38ec2",
        "storage_key": "property/6767906449166921/019f15b3-e944-7378-a13a-732591f38ec2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattlemonorail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13535058097728434004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-center-monorail",
      "poi_latitude": "47.6212828",
      "poi_longitude": "-122.3497545",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-905-2620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-502a-703f-8f12-599650fb25c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddcc-502a-703f-8f12-599650fb25c1",
        "storage_key": "property/6767906449166921/019fddcc-502a-703f-8f12-599650fb25c1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJOWl1d0YVkFQRVK9gyaAv1rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_db06fa1423734b2c2a3e9d73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Seattle Streetcar Depot - South Lake Union Line",
      "poi_type": "Transportation & Transit",
      "poi_address": "318 Fairview Ave N Unit 318, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-aacd-74f8-9db8-93441b99d80e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-aacd-74f8-9db8-93441b99d80e",
        "storage_key": "property/6767906449166921/01a03f58-aacd-74f8-9db8-93441b99d80e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4968656724231590767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-streetcar-depot---south-lake-union-line",
      "poi_latitude": "47.6213033",
      "poi_longitude": "-122.3337979",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfc2y4DYVkFQRbxOuMvc29EQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "ec_cb1d4cd2e32ff468ae03aace",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Vashon service at Pier 50",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 Alaskan Wy, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-ec2e-77a8-aee4-c104bd450d33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-ec2e-77a8-aee4-c104bd450d33",
        "storage_key": "property/6767906449166921/019f15b3-ec2e-77a8-aee4-c104bd450d33.webp",
        "width": 1280,
        "height": 899
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13277338512470304411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vashon-service-at-pier-50",
      "poi_latitude": "47.60122",
      "poi_longitude": "-122.33893",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-502a-703f-8f12-599650fb25c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddcc-502a-703f-8f12-599650fb25c1",
        "storage_key": "property/6767906449166921/019fddcc-502a-703f-8f12-599650fb25c1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJcUsGgq9qkFQRm-Zn3geVQrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferry_terminal"
    },
    {
      "id": "ec_dfe6e7bb6478fea461fe0295",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Seattle, Washington King Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "303 S Jackson St, Seattle, WA 98104, USA",
      "poi_short_description": "This working train station built in 1906 features a brick & granite facade & a 12-story clock tower.",
      "poi_long_description": "This working train station built in 1906 features a brick & granite facade & a 12-story clock tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b3-eceb-759b-b57a-8105861ebe0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b3-eceb-759b-b57a-8105861ebe0c",
        "storage_key": "property/6767906449166921/019f15b3-eceb-759b-b57a-8105861ebe0c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/transportation/kingstreet.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15505356831325706598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-washington-king-street-station",
      "poi_latitude": "47.5983889",
      "poi_longitude": "-122.3299086",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-502a-703f-8f12-599650fb25c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddcc-502a-703f-8f12-599650fb25c1",
        "storage_key": "property/6767906449166921/019fddcc-502a-703f-8f12-599650fb25c1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJy_gXRbtqkFQRZlnYHuMXLtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_88429168d80a16d52d192d4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Seattle-Tacoma International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "17801 International Blvd, SeaTac, WA 98158, USA",
      "poi_short_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_long_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-c229-749c-84e0-603f77e78323.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-c229-749c-84e0-603f77e78323",
        "storage_key": "property/6767906449166921/019cfde3-c229-749c-84e0-603f77e78323.webp",
        "width": 1200,
        "height": 798
      },
      "poi_business_url": "https://www.portseattle.org/sea-tac",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084442547078838199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-tacoma-international-airport",
      "poi_latitude": "47.4483652",
      "poi_longitude": "-122.3085927",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 23 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d84a-73b3-9674-d12fc6f54b31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d84a-73b3-9674-d12fc6f54b31",
        "storage_key": "property/6767906449166921/019cfde3-d84a-73b3-9674-d12fc6f54b31.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f7qQlVDkFQRtzfcx8TZ05k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_25998b63282ceb239f10fbcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Amazon Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "440 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-c517-725e-9378-d0378256ab3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-c517-725e-9378-d0378256ab3d",
        "storage_key": "property/6767906449166921/019cfde3-c517-725e-9378-d0378256ab3d.webp",
        "width": 568,
        "height": 346
      },
      "poi_business_url": "https://www.aboutamazon.com/workplace/corporate-offices",
      "poi_directions_map_url": "https://maps.google.com/?cid=15534617866147706229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-corporate-headquarters",
      "poi_latitude": "47.6227501",
      "poi_longitude": "-122.3367548",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-266-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxQbczcVkFQRdbUrsaQMltc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_260d28a10baa80e414b55981",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Fred Hutch Cancer Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1354 Aloha St, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-42e0-73b9-abd7-bc4a743d545b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddcc-42e0-73b9-abd7-bc4a743d545b",
        "storage_key": "property/6767906449166921/019fddcc-42e0-73b9-abd7-bc4a743d545b.webp",
        "width": 1022,
        "height": 575
      },
      "poi_business_url": "https://www.fredhutch.org/?utm_source=gbp&utm_medium=organic&utm_content=primary_business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13660788334964817360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-hutch-cancer-center",
      "poi_latitude": "47.626675",
      "poi_longitude": "-122.330091",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 855-557-0555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzT5V0iQVkFQR0L1g2ZzelL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_28298bdb86317a6079cfb19e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Allen Institute",
      "poi_type": "Education",
      "poi_address": "615 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-45f6-774e-a0e3-ea4964bbac38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddcc-45f6-774e-a0e3-ea4964bbac38",
        "storage_key": "property/6767906449166921/019fddcc-45f6-774e-a0e3-ea4964bbac38.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://alleninstitute.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=234336328026493092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allen-institute",
      "poi_latitude": "47.6252444",
      "poi_longitude": "-122.339089",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-548-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51f-70db-b172-d7ad228581f3",
        "storage_key": "property/6767906449166921/019cfde3-d51f-70db-b172-d7ad228581f3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJZpF1KkVkFQRpBD9FaaHQAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "ec_52760329eafbaac7def4b58d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Gates Foundation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 5th Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019fddcc-44a2-764f-8738-475bd99a9633.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddcc-44a2-764f-8738-475bd99a9633",
        "storage_key": "property/6767906449166921/019fddcc-44a2-764f-8738-475bd99a9633.webp",
        "width": 1280,
        "height": 1013
      },
      "poi_business_url": "http://gatesfoundation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12667357819156295453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gates-foundation",
      "poi_latitude": "47.6233319",
      "poi_longitude": "-122.3465813",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-709-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d51d-70dd-ae64-837ef2a0c0ca",
        "storage_key": "property/6767906449166921/019cfde3-d51d-70dd-ae64-837ef2a0c0ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3d0rEcVkFQRHe-TbdJ-y68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_45eafdf78f520d30a2d962b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Seattle Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Sand Point Way NE, Seattle, WA 98105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019f15b1-1e55-750d-bd50-d9c145d08b3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f15b1-1e55-750d-bd50-d9c145d08b3a",
        "storage_key": "property/6767906449166921/019f15b1-1e55-750d-bd50-d9c145d08b3a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.seattlechildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11535247879101277020&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-childrens-hospital",
      "poi_latitude": "47.6628364",
      "poi_longitude": "-122.281996",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-987-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d555-773c-9cd4-25a192d54a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d555-773c-9cd4-25a192d54a59",
        "storage_key": "property/6767906449166921/019cfde3-d555-773c-9cd4-25a192d54a59.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYx10YIUkFQRXOPoZdRuFaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_1c7f36e9cd14fb846e37a3cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "King County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 3rd Ave, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-cd5a-7403-b055-8973843ccc3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-cd5a-7403-b055-8973843ccc3b",
        "storage_key": "property/6767906449166921/019cfde3-cd5a-7403-b055-8973843ccc3b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kingcounty.gov/about/contact-us/locations/Courthouse.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15425142603987560826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-county-courthouse",
      "poi_latitude": "47.6027783",
      "poi_longitude": "-122.3304087",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-477-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d858-758a-acba-cddfdd3be3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d858-758a-acba-cddfdd3be3a3",
        "storage_key": "property/6767906449166921/019cfde3-d858-758a-acba-cddfdd3be3a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDRNoY7pqkFQReils8HgdEdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "ec_0fc90fdf3c3d0d2c665172db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Seattle City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 4th Ave, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-cc0c-7207-bced-cc5a1b6ad7c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-cc0c-7207-bced-cc5a1b6ad7c7",
        "storage_key": "property/6767906449166921/019cfde3-cc0c-7207-bced-cc5a1b6ad7c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12499598841282423791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-city-hall",
      "poi_latitude": "47.6038106",
      "poi_longitude": "-122.3299368",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-684-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d858-758a-acba-cddfdd3be3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d858-758a-acba-cddfdd3be3a3",
        "storage_key": "property/6767906449166921/019cfde3-d858-758a-acba-cddfdd3be3a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVY3XoLBqkFQR7-uFoet-d60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_617fbe1ac8f80232fd23eecc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "generator",
      "poi_name": "Port of Seattle",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2711 Alaskan Wy, Seattle, WA 98121, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/01a03f58-ac58-77fe-a6cc-392482e75a6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03f58-ac58-77fe-a6cc-392482e75a6b",
        "storage_key": "property/6767906449166921/01a03f58-ac58-77fe-a6cc-392482e75a6b.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.portseattle.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17900442876227586198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-of-seattle",
      "poi_latitude": "47.613829",
      "poi_longitude": "-122.354308",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-787-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde3-d858-758a-acba-cddfdd3be3a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde3-d858-758a-acba-cddfdd3be3a3",
        "storage_key": "property/6767906449166921/019cfde3-d858-758a-acba-cddfdd3be3a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM1ivl1EVkFQRloi3j_Qla_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_bf62062b3543dff17c4bdf4d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ae8939f4ac0ed24b156f0302",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4ab3b18715e339256d95f78d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1f63c2f3e77025ead36f4227",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f2663c64a1bfb74a7bfb63a2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fbe6e498305f187c1552bfd6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_0edb62da-80e4-42a3-8f87-06eb428f1b12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "rating": "5.0",
      "name": "Amy Thomas",
      "text": "My experience at 110 Roy has been exceptional. Beautiful property and well maintained!! It is the team that really shines. Nathalie made me feel at home as soon as I walked in the door for my tour and helped me find the perfect apartment. She is kind and thoughtful!! Blake has been quick to communicate and very helpful. I feel very lucky to have come across this building!! Neighborhood is also lovely, super walkable, and close to everything! I definitely recommend!",
      "date": "2025-09-17",
      "title": ""
    },
    {
      "id": "custom_d349fd26-153c-4b77-914b-3ec4dd4bc8d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "rating": "5.0",
      "name": "Zach Capozzi",
      "text": "I have lived at 110 Roy for a couple of months now and I cannot say enough great things about the entire staff, from leasing to maintenance. A special thank you to Blake, the maintenance supervisor, for the outstanding service he provides.\n\nI’ve lived in several apartment complexes over the years, and I can confidently say that I’ve never experienced such professionalism, responsiveness, and care from an apartment complex.",
      "date": "2025-08-28",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cba7c-409f-7044-8cf8-682bc5296318",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "sandbox-test-site",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921"
    },
    {
      "lead_collector_id": "019d16ec-5d78-710d-b3d6-ab5ae0ce919f",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921"
    },
    {
      "lead_collector_id": "019e2c89-deb6-70d2-8d3a-1458f138f3dc",
      "lead_source": "LANDING_PAGE",
      "name": "110 Royy Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "page_item_url": "highrise-apartments-that-allow-bunnies-110-roy",
      "search_query": "highrise apartments that allow bunnies",
      "category": "false",
      "h1_title": "Bunny-Friendly Highrise Apartments",
      "h2_subtitle": "Explore our highrise apartments that allow bunnies. No need to leave furry friends behind at 110 Roy!",
      "page_copy": "Embrace a pet-inclusive lifestyle at 110 Roy, where our highrise apartments that allow bunnies offer a welcoming environment. Located in the vibrant Lower Queen Anne area of Seattle, these homes feature spacious layouts with private balconies in most residences, perfect for accommodating small pets like bunnies. Our community extends its warmth to pets with convenient services that ensure comfort and care for all residents.\n\nInside 110 Roy, enjoy modern layouts ranging from studios to two-bedroom configurations, complete with high-end finishes. The on-site amenities, such as a rooftop terrace and 24-hour fitness studio, blend convenience with leisure. Plus, with controlled access and community-wide WiFi, you and your bunny friends will feel right at home. Discover the unique charm of our pet-friendly highrise today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-7895-70fe-bc42-46d10290ad0a.webp",
      "featured_image_media": {
        "alt_text": "Exterior aerial view of a modern apartment building with balconies and \"Now Open\" signs.",
        "public_id": "019cfde2-7895-70fe-bc42-46d10290ad0a",
        "storage_key": "property/6767906449166921/019cfde2-7895-70fe-bc42-46d10290ad0a.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bunny-Friendly Highrise Apartments in Seattle",
      "seo_description": "Find bunny-friendly highrise apartments at 110 Roy, Seattle. Spacious layouts and pet amenities await!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "page_item_url": "luxury-apartments-skyline-views-seattle-wa",
      "search_query": "luxury apartments with skyline views seattle wa",
      "category": "Amenity",
      "h1_title": "High Rise Apartments with Skyline Views",
      "h2_subtitle": "Experience the best of Seattle with luxury apartments featuring breathtaking skyline views. Discover upscale living in the heart of Seattle's Uptown neighborhood.",
      "page_copy": "Nestled within the vibrant Uptown neighborhood, 110 Roy offers luxury apartments with skyline views of Seattle, WA. These spacious homes captivate with expansive light-filled windows, providing a panoramic gateway to the city’s iconic skyline. At 110 Roy, you'll find thoughtfully designed living spaces featuring primary bedrooms with designer walk-in closets, ideal for elevating your everyday living. \n\nBeyond the comfort of your apartment, immerse yourself in exceptional amenities like a resident lounge equipped for both relaxation and productivity. With nearby access to the Elliott Bay Waterfront and Myrtle Edwards Park, outdoor enthusiasts will appreciate the accessible bicycle trail coupled with the urban sophistication these luxury apartments offer. Discover unparalleled views and luxury living at 110 Roy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166921/019cfde2-8c97-74da-bb38-b346220dc467.webp",
      "featured_image_media": {
        "alt_text": "Stylish communal lounge area with a blue sofa, armchairs, fireplace, and large windows.",
        "public_id": "019cfde2-8c97-74da-bb38-b346220dc467",
        "storage_key": "property/6767906449166921/019cfde2-8c97-74da-bb38-b346220dc467.webp",
        "width": 1920,
        "height": 1282
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Skyline Views",
      "seo_description": "Discover luxury apartments with skyline views in Seattle, WA. Experience prime amenities and vibrant Uptown living at 110 Roy.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166921",
      "source": "custom",
      "page_item_url": "apartments-air-conditioning-uptown-seattle",
      "search_query": "apartments with air conditioning in uptown seattle",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning Uptown",
      "h2_subtitle": "Stay comfortable year-round in Uptown Seattle apartments with air conditioning. Discover the perfect blend of modern living and convenience at 110 Roy.",
      "page_copy": "Located in the heart of Seattle's vibrant Uptown neighborhood, 110 Roy is the perfect place for those seeking apartments with air conditioning. Enjoy modern comforts while staying cool during Seattle's warm summer months. Our thoughtfully designed units feature expansive, light‑filled windows, offering an inviting atmosphere in every room.\n\nYou'll also benefit from an array of amenities, including a resident lounge equipped with private work-from-home spaces and entertainment options like a pool table and television. The controlled access garage offers both guest parking and EV charging stations. With nearby access to the Elliot Bay Waterfront and Myrtle Edwards Park, enjoying the outdoors is as easy as stepping outside the door. Choose 110 Roy for an unparalleled living experience in Uptown Seattle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning Uptown",
      "seo_description": "Find apartments with air conditioning in Uptown Seattle. Enjoy modern comforts and excellent amenities at 110 Roy.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a0f\"></script><img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a0f\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_google_tag_manager",
      "type": "STRING",
      "value": "GTM-WDSG6W6M"
    },
    {
      "ID": "custom_pixel_tracking_url",
      "type": "STRING",
      "value": "https://jelly.mdhv.io/v1/star.gif?pid=6V02Tl0bQmSQCXJsVBE86nUodv0X&src=mh&evt=hiasdfasd_dafsdfasd_fasdfwegn_adgaergaeg"
    },
    {
      "ID": "custom_google_site_verification",
      "type": "STRING",
      "value": "oYai9AWL3o7a8cPwvmjI9LAFPVI8SQc2DMVDBR_JAfk"
    }
  ],
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a0f\"></script><img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a0f\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_google_tag_manager": "GTM-WDSG6W6M",
  "custom_pixel_tracking_url": "https://jelly.mdhv.io/v1/star.gif?pid=6V02Tl0bQmSQCXJsVBE86nUodv0X&src=mh&evt=hiasdfasd_dafsdfasd_fasdfwegn_adgaergaeg",
  "custom_google_site_verification": "oYai9AWL3o7a8cPwvmjI9LAFPVI8SQc2DMVDBR_JAfk"
};

export const generatedAt = '2026-09-23T20:46:09.013Z';
